import Modal from "../Reusable/Modal";
import { Button } from "../Reusable/Button";
import DataUpLogo from "../../assets/images/DataUpLogoAuth.svg";
import manworking from "../../assets/images/manworking.svg";
import { useModal } from "../../context/ModalContext";

const ConfirmationModal: React.FC = () => {
  const { isConfirmationOpen, closeConfirmationModal, openLoginModal } =
    useModal();
  return (
    <Modal
      isOpen={isConfirmationOpen}
      onClose={closeConfirmationModal}
      className="h-[391px] w-[484px]"
    >
        <div className="">
        <div className="flex justify-center mb-4">
        <img
          src={DataUpLogo}
          alt="DatauplogoAuth"
          className="w-[135.55px] h-[32px]"
        />
      </div>
      <div className="flex justify-center mb-4">
        <img
          src={manworking}
          alt="DatauplogoAuth"
          className="w-[222px] h-[166.5px]"
        />
      </div>

      <h2 className="text-2xl font-bold text-center dark:text-white">
        Request has been submitted
      </h2>
      <p className="text-center text-sm text-gray-500 mb-4 dark:text-white">
        An admin will get in touch with you with the next steps .
      </p>

      <Button
        onClick={() => {
          closeConfirmationModal();
          openLoginModal();
        }}
        bgColor="bg-white"
        className="flex-1 w-full border border-gray-300"
        borderRadius="rounded-lg"
      >
        Back to Sign in
      </Button>
        </div>
      
    </Modal>
  );
};
export default ConfirmationModal;
